const AboutUsPage = () => (
  <div className="p-8 bg-white rounded-lg shadow-xl">
    <h2 className="text-3xl font-bold text-gray-800 mb-6">
      About Our Yoga Studio
    </h2>
    <div className="prose max-w-none text-gray-700">
      <p className="mb-4">
        Welcome to Yogavantha, your dedicated sanctuary for holistic health and
        well-being through the transformative practice of yoga. Established with
        a profound commitment to making the numerous benefits of yoga accessible
        to everyone, Yogavantha has grown into a reputable center with multiple
        conveniently located branches across Bangalore. You can find us
        nurturing mindful communities in Nagadevanahalli (Kengeri), Bharat Nagar
        (Magadi Road), and Mallathahalli (Ullal).
      </p>
      <p className="mb-4">
        At Yogavantha, we believe that yoga is more than just physical postures;
        it's a journey towards self-discovery, inner peace, and a harmonious
        life. Our philosophy centers on creating a supportive and inspiring
        environment where individuals of all ages and experience levels can
        explore the profound wisdom of yoga. Whether you're a complete beginner
        seeking to understand the fundamentals or an experienced practitioner
        looking to deepen your practice, our diverse range of classes is
        designed to cater to your unique needs and aspirations.
      </p>
      <p className="mb-2 font-semibold">Our Approach to Yoga</p>
      <p className="mb-4">
        Under the guidance of Prashanth Yogavantha, a seasoned yogi with over
        two decades of practice and extensive teaching experience, our center
        upholds the highest standards of yoga instruction. Prashanth, who has
        influenced countless individuals globally and is recognized with the
        prestigious "Yoga Bhushana" by the Government of India, leads a team of
        dedicated and highly qualified instructors. They bring a wealth of
        knowledge in various yoga styles, ensuring a comprehensive and enriching
        experience for all students.
        <br />
        We emphasize a balanced approach that integrates physical postures
        (asanas), breathing techniques (pranayama), and meditation, fostering
        not only physical strength and flexibility but also mental clarity and
        emotional balance. Our classes are crafted to enhance your overall
        fitness, improve concentration, reduce stress, and promote a sense of
        calm and well-being in your daily life. We aim to equip you with tools
        to navigate life's challenges with greater resilience and a positive
        outlook.
      </p>
      <p className="mb-2 font-semibold">Join Our Community</p>
      <p>
        Yogavantha is more than just a yoga class; it's a vibrant community
        where like-minded individuals come together to share their journey
        towards a healthier lifestyle. We pride ourselves on the positive
        feedback and success stories from our students, which stand as a
        testament to our commitment to excellence and customer satisfaction.
        <br />
        Discover the transformative power of yoga with Yogavantha. We invite you
        to step onto the mat with us and embark on a path to a more balanced,
        energetic, and fulfilling life. Connect with us on our social media
        platforms to stay updated on our offerings, special events, and insights
        into the world of yoga.
      </p>
    </div>
  </div>
);

export default AboutUsPage;
